<app-dialog-header
	[title]="'newuser.dialog.title'"
	variant="info"
></app-dialog-header>
<mat-dialog-content
	class="center-block"
	style="margin-top: 10px"
>
	<form
		class="example-container"
		[formGroup]="newUserForm"
	>
		<mat-form-field
			floatLabel="auto"
			style="padding-top: 30px"
		>
			<input
				matInput
				formControlName="email"
				[placeholder]="'newUser.dialog.email' | translate"
			/>
		</mat-form-field>
	</form>

	<a
		[class.disabled]="newUserForm.invalid"
		(click)="sendEmail()"
		class="btn btn-blue text-uppercase"
	>
		<i
			class="fa fa-envelope"
			style="padding-right: 8px"
		></i>
		{{ "newUser.dialog.sendEmail" | translate }}
	</a>
</mat-dialog-content>
